export const MAX_Y = screen.height; // 바텀시트가 최소로 내려갔을 때의 y 값
export const BOTTOM_SHEET_HEIGHT = screen.height; // 바텀시트의 세로 길이
